export default "__VITE_ASSET__CqykegwM__"